import { IUser } from '@/@types'
import { Svg } from '@/components'
import { ColumnHeader } from '@/components/data-table/column-header'
import { useCollaboratorStore } from '@/stores/collaborators'
import { Delete, Settings } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import { ColumnDef } from '@tanstack/react-table'
import { format } from 'date-fns'

export function MakeTABLE_COLUMNS({
  deleteItem,
  id,
}: {
  deleteItem: (id: string) => Promise<void>
  id: string | undefined
}): ColumnDef<IUser>[] {
  const { setCollaboratorID } = useCollaboratorStore()

  return [
    {
      id: 'name',
      accessorKey: 'name',
      header: 'Nome',
      cell: ({ row }) => (
        <div className="flex gap-2 items-center">
          <Svg src="/person.svg" className="max-w-6" />
          <span>{`${row.original.name} ${row.original.surname}`}</span>
        </div>
      ),
    },
    {
      id: 'id',
      accessorKey: 'id',
      header: ({ column }) => <ColumnHeader column={column} title="Id" />,
    },
    {
      id: 'accessLevel',
      accessorKey: 'accessLevel',
      header: 'Nível de Acesso',
      cell: ({ row }) => `${row.original.accessLevel}`,
    },
    {
      id: 'createdAt',
      accessorKey: 'createdAt',
      header: ({ column }) => (
        <ColumnHeader column={column} title="Criado em" />
      ),
      cell: ({ row }) => format(row.original.createdAt, 'dd MMM yyyy'),
    },
    {
      id: 'Actions',
      accessorKey: 'Actions',
      header: ({ column }) => <ColumnHeader column={column} title="Ações" />,
      cell: ({ row }) => {
        const userId = row.original.id
        return (
          <div className="flex flex-wrap gap-1 items-center">
            <IconButton
              sx={{ color: 'white' }}
              onClick={() => {
                if (userId) {
                  setCollaboratorID(userId)
                }
              }}
            >
              <Settings />
            </IconButton>

            <IconButton
              disabled={id === userId}
              sx={{ color: 'white' }}
              onClick={async () => {
                await deleteItem(userId)
              }}
            >
              <Delete />
            </IconButton>
          </div>
        )
      },
    },
  ]
}
